import React, { useEffect, useState } from 'react';
import PaginationOptions, { Page } from '../../../../api/ui/paginationOptions';
import { useDispatch } from 'react-redux';
import { DEFAULT_END_AT, DEFAULT_START_AT } from '../../constants';
import { Helmet } from 'react-helmet';
import Visible from '../../../../components/Custom/Visible';
import PaginationComponent from '../../../../components/Custom/PaginationComponent';
import Notification from '../../../../components/Notification/Notification';
import { nftRestoreLogListRequest } from '../../../../redux/actions/log/nftRestoreLogAction';
import useTranslation from '../../../../hooks/useTranslation';
import useSchemaRestoreLog from '../../../../schema/table-schema/useSchemaRestoreLog';
import BOTable from '../../../../components/Tables/BOTable';
import {UIConstants} from "../../../../constants/UIConstants";
import {
    SearchBtnContainer,
    SearchContainer, SearchContent,
    SearchDateRange,
    SearchLabel,
    SearchRow
} from "../../../../components/Search/searchSection";

function NFTRestoreLogMain() {
  // -- component const --//
  // 페이지 제목
  const title = 'admin.log.perplay.restore.title'; // '차량 복원 로그';

  const OPTION_KEY = Page.LOG_PERPLAY_NFT_RESTORE;

  const { t } = useTranslation();
  const { schema } = useSchemaRestoreLog();

  // -- useSelector & dispatch --//
  const dispatch = useDispatch();

  // -- state --//
  const [logList, setLogList] = useState();
  const [totalCount, setTotalCount] = useState(0);
  const [notificationMessage, setNotificationMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  // 페이지 옵션
  const [pageOption, setPageOption] = useState();
  const [pageLength, setPageLength] = useState(25);
  const [page, setPage] = useState(1);

  const [startAt, setStartAt] = useState(DEFAULT_START_AT);
  const [endAt, setEndAt] = useState(DEFAULT_END_AT);

  // 로딩
  const [isLoading, setIsLoading] = useState(false);

  // 검색
  const [account, setAccount] = useState('');
  const [nftUid, setNftUid] = useState(0);
  const [transactionNo, setTransactionNo] = useState(0);
  const [isReset, setIsReset] = useState(false);

  // -- func & handler --//
  const fetchList = () => {
    setIsLoading(true);

    dispatch(
      nftRestoreLogListRequest({
        page: page,
        pageLength: Number(pageLength),
        beginDate: startAt,
        endDate: endAt,
        account: account,
        nftUid: nftUid,
        transactionNo: transactionNo,
        callback: (data) => {
          console.log(data);
          setIsLoading(false);
          setLogList(data.list);
          setTotalCount(data.totalCount);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);
          setIsLoading(false);
        },
      }),
    );
  };

  const handlePageChange = (_, value) => {
    setPage(Number(value));
  };

  const handlePageLengthChange = (value) => {
    setPageLength(value);
    setPage(1);
  };

  const handleSearchClick = () => {
    if (page === 1) {
      fetchList();
      return;
    }

    setPage(1);
  };

  const handleResetClick = () => {
      setAccount("");
      setNftUid(0);
      setTransactionNo(0);
      setIsReset(true);
  }


  // -- react hooks --//
  useEffect(() => {
    PaginationOptions.getInstance().then((instance) => {
      const option = instance?.getData(OPTION_KEY);
      setPageOption(option);

      if (option.list_count_elements?.length > 0) {
        setPageLength(Number(25));
      }
    });
  }, [OPTION_KEY]);

  useEffect(() => {
    fetchList();
  }, [page, pageLength]);

  useEffect(() => {
      if(isReset) {
          setIsReset(false);
          fetchList();
      }
  }, [isReset]);

  // -- render --//
  return (
    <div className="page">
      <Helmet>
        <title>{t(title)}</title>
      </Helmet>

      <div className="topSection">
          <div className="leftSection">
              <p className="titleText">{t(title)}</p>
          </div>
      </div>

      <div className="spaceDiv10"/>

        <section>
            <SearchContainer>
                <SearchRow>
                    <SearchLabel text={UIConstants.Date}/>
                    <SearchDateRange
                        startAt={startAt}
                        endAt={endAt}
                        setStartAt={setStartAt}
                        setEndAt={setEndAt}
                    />
                </SearchRow>

                <SearchRow>
                    <SearchLabel text={UIConstants.UserId}/>
                    <SearchContent>
                        <input
                            className=""
                            placeholder={UIConstants.UserId}
                            value={account || ""}
                            onChange={(e) => {
                                setAccount(e.target.value);
                            }}
                        />
                    </SearchContent>

                    <SearchLabel text={UIConstants.NftUid}/>
                    <SearchContent>
                        <input
                            className=""
                            placeholder={UIConstants.NftUid}
                            value={nftUid || ""}
                            onChange={(e) => {
                                setNftUid(Number(e.target.value));
                            }}
                        />
                    </SearchContent>

                    <SearchLabel text={UIConstants.TransactionNo}/>
                    <SearchContent>
                        <input
                            className=""
                            placeholder={UIConstants.TransactionNo}
                            value={transactionNo || ""}
                            onChange={(e) => {
                                setTransactionNo(Number(e.target.value));
                            }}
                        />
                    </SearchContent>
                </SearchRow>
            </SearchContainer>

            <SearchBtnContainer
                handleSearchClick={handleSearchClick}
                handleResetClick={handleResetClick}
            />
        </section>

      <div className="spaceDiv10"/>

      <Visible Visible visible={pageOption?.top_paging}>
        <PaginationComponent
          disable={false}
          option={pageOption}
          page={page}
          pageLength={pageLength}
          totalCount={totalCount}
          onChange={handlePageChange}
          onSelect={handlePageLengthChange}
        />
      </Visible>

      <div className="spaceDiv10"/>

      <BOTable
        schema={schema}
        rows={logList}
        loading={isLoading}
        onClick={null}
      />

      <div className="spaceDiv10"/>

      <Visible Visible visible={pageOption?.bottom_paging}>
        <PaginationComponent
          disable={false}
          option={pageOption}
          page={page}
          pageLength={pageLength}
          totalCount={totalCount}
          onChange={handlePageChange}
          onSelect={handlePageLengthChange}
        />
      </Visible>

      {showNotification ? (
        <Notification
          close={() => setShowNotification(false)}
          message={notificationMessage}
        />
      ) : null}
    </div>
  );
}

export default NFTRestoreLogMain;
